import { FormLabel, GridLegacy, Skeleton, Tooltip } from "@mui/material";
import React, { useState } from "react";

// core components
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import TranslationWrapper, { getTranslation } from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import Button from "../../../components/CustomButtons/Button";
import { FileCopy } from "@mui/icons-material";
import { useController, useFormContext, useWatch } from "react-hook-form";
import FormText from "../../../components/Forms/FormText";
import FormAsync from "../../../components/Forms/FormAsync";
import FormAsyncTC from "../../../components/Forms/FormAsyncTC";
import CopyVrijeOpties from "../Modals/CopyVrijeOpties";
import { AsyncProductAutocomplete } from "../../../components/Forms/AsyncAutocomplete/Product/AsyncProductAutocompleteTC";

function Vrijeopties() {
  const [open, setOpen] = useState(false);
  const [selectedField, setSelectedField] = useState(false);
  const { menukaartVestigingId, vestigingId } = useFormContext();
  const freeOptions = useWatch({ name: "freeOptions" });
  const freeOptions2 = useWatch({ name: "freeOptions2" });
  const freeOptions3 = useWatch({ name: "freeOptions3" });
  const freeOptionsRequired = useWatch({ name: "freeOptionsRequired" });
  const freeOptionsRequired2 = useWatch({ name: "freeOptionsRequired2" });
  const freeOptionsRequired3 = useWatch({ name: "freeOptionsRequired3" });
  const id = useWatch({ name: "id" });
  const {
    field: { value: products, onChange: onChange },
  } = useController({ name: "freeOptions" });

  const {
    field: { value: products2, onChange: onChange2 },
  } = useController({ name: "freeOptions2" });

  const {
    field: { value: products3, onChange: onChange3 },
  } = useController({ name: "freeOptions3" });

  return (
    <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody>
          <GridLegacy container spacing={1}>
            <GridLegacy item xs={12}>
              <h3>
                <TranslationWrapper tDefault={"Selectable items"} tKey={"producten.form.vrijeopties.title"} />
              </h3>
            </GridLegacy>
            <GridLegacy item key={"freeOptions"} lg={4} xs={12}>
              <FormLabel>
                <h3>
                  <TranslationWrapper
                    tDefault={"Vrije opties producten"}
                    tKey={"producten.form.vrijeopties.label.freeOptions"}
                  />
                  1
                  <Tooltip title={<TranslationWrapper tDefault={"Kopieer"} tKey={"global.tooltip.kopieer"} />}>
                    <Button
                      justIcon
                      onClick={() => {
                        setSelectedField(freeOptions);
                        setOpen(true);
                      }}
                      size={"sm"}
                    >
                      <FileCopy />
                    </Button>
                  </Tooltip>
                </h3>
              </FormLabel>
              <FormText
                fieldProps={{ placeholder: getTranslation("producten.upsell.freeoptions.title", "Title") }}
                name={"freeOptionsTitle"}
              />
              {products !== undefined ? (
                <AsyncProductAutocomplete
                  async_url={`core/producten/search?fields=id as value,naam as label,blocked,is_actief,snaam,prijs&sort_field=naam&vestiging_id=${
                    menukaartVestigingId ?? vestigingId
                  }&extraFilters=[${encodeURIComponent(
                    JSON.stringify([{ field: "apiId2", operator: "=", value: null }])
                  )}]`}
                  multiple={true}
                  name={"freeOptions"}
                  onChange={(option) => {
                    onChange(JSON.stringify(option.map((option) => option.value)));
                  }}
                  tDefault={"Extra settings"}
                  tKey={"extra_settings__tcProduct" + menukaartVestigingId}
                  value={JSON.parse(products)}
                />
              ) : (
                <Skeleton variant={"rectangular"} />
              )}
            </GridLegacy>
            <GridLegacy item key={"freeOptions2"} lg={4} xs={12}>
              <FormLabel>
                <h3>
                  <TranslationWrapper
                    tDefault={"Vrije opties producten"}
                    tKey={"producten.form.vrijeopties.label.freeOptions"}
                  />
                  2
                  <Tooltip title={<TranslationWrapper tDefault={"Kopieer"} tKey={"global.tooltip.kopieer"} />}>
                    <Button
                      justIcon
                      onClick={() => {
                        setSelectedField(freeOptions2);
                        setOpen(true);
                      }}
                      size={"sm"}
                    >
                      <FileCopy />
                    </Button>
                  </Tooltip>
                </h3>
              </FormLabel>
              <FormText
                fieldProps={{ placeholder: getTranslation("producten.upsell.freeoptions.title", "Title") }}
                name={"freeOptionsTitle2"}
              />
              {products2 !== undefined ? (
                <AsyncProductAutocomplete
                  async_url={`core/producten/search?fields=id as value,naam as label,blocked,is_actief,snaam,prijs&sort_field=naam&vestiging_id=${
                    menukaartVestigingId ?? vestigingId
                  }&extraFilters=[${encodeURIComponent(
                    JSON.stringify([{ field: "apiId2", operator: "=", value: null }])
                  )}]`}
                  multiple={true}
                  name={"freeOptions2"}
                  onChange={(option) => {
                    onChange2(JSON.stringify(option.map((option) => option.value)));
                  }}
                  tDefault={"Extra settings"}
                  tKey={"freeOptions2" + (menukaartVestigingId ?? vestigingId)}
                  value={products2 == "" ? [] : JSON.parse(products2)}
                />
              ) : (
                <Skeleton variant={"rectangular"} />
              )}
            </GridLegacy>
            <GridLegacy item key={"freeOptions3"} lg={4} xs={12}>
              <FormLabel>
                <h3>
                  <TranslationWrapper
                    tDefault={"Vrije opties producten"}
                    tKey={"producten.form.vrijeopties.label.freeOptions"}
                  />
                  3
                  <Tooltip title={<TranslationWrapper tDefault={"Kopieer"} tKey={"global.tooltip.kopieer"} />}>
                    <Button
                      justIcon
                      onClick={() => {
                        setSelectedField(freeOptions3);
                        setOpen(true);
                      }}
                      size={"sm"}
                    >
                      <FileCopy />
                    </Button>
                  </Tooltip>
                </h3>
              </FormLabel>
              <FormText
                fieldProps={{ placeholder: getTranslation("producten.upsell.freeoptions.title", "Title") }}
                name={"freeOptionsTitle3"}
              />
              {products3 !== undefined ? (
                <AsyncProductAutocomplete
                  async_url={`core/producten/search?fields=id as value,naam as label,blocked,is_actief,snaam,prijs&sort_field=naam&vestiging_id=${
                    menukaartVestigingId ?? vestigingId
                  }&extraFilters=[${encodeURIComponent(
                    JSON.stringify([{ field: "apiId2", operator: "=", value: null }])
                  )}]`}
                  multiple={true}
                  name={"freeOptions3"}
                  onChange={(option) => {
                    onChange3(JSON.stringify(option.map((option) => option.value)));
                  }}
                  tDefault={"Extra settings"}
                  tKey={"freeOptions3" + (menukaartVestigingId ?? vestigingId)}
                  value={products3 == "" ? [] : JSON.parse(products3)}
                />
              ) : (
                <Skeleton variant={"rectangular"} />
              )}
            </GridLegacy>
            <GridLegacy item key={"freeOptionsRequired"} lg={4} xs={12}>
              <FormLabel>
                <h3>
                  <TranslationWrapper
                    tDefault={"Vrije opties producten (verplichte keuze)"}
                    tKey={"producten.form.vrijeopties.label.freeOptionsRequired"}
                  />
                  1
                  <Tooltip title={<TranslationWrapper tDefault={"Kopieer"} tKey={"global.tooltip.kopieer"} />}>
                    <Button
                      justIcon
                      onClick={() => {
                        setSelectedField(freeOptionsRequired);
                        setOpen(true);
                      }}
                      size={"sm"}
                    >
                      <FileCopy />
                    </Button>
                  </Tooltip>
                </h3>
              </FormLabel>
              <FormText
                fieldProps={{ placeholder: getTranslation("producten.upsell.freeoptions.title", "Title") }}
                name={"freeOptionsRequiredTitle"}
              />
              <FormAsync
                async={{
                  url:
                    "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                    (menukaartVestigingId ?? vestigingId),
                  searchField: "naam",
                  extraFilters: [
                    {
                      field: "apiId2",
                      operator: "=",
                      value: null,
                    },
                  ],
                }}
                key={"freeOptionsRequired" + (menukaartVestigingId ?? vestigingId)}
                multiple={true}
                name={"freeOptionsRequired"}
              />
            </GridLegacy>
            <GridLegacy item key={"freeOptionsRequired2"} lg={4} xs={12}>
              <FormLabel>
                <h3>
                  <TranslationWrapper
                    tDefault={"Vrije opties producten (verplichte keuze)"}
                    tKey={"producten.form.vrijeopties.label.freeOptionsRequired"}
                  />
                  2
                  <Tooltip title={<TranslationWrapper tDefault={"Kopieer"} tKey={"global.tooltip.kopieer"} />}>
                    <Button
                      justIcon
                      onClick={() => {
                        setSelectedField(freeOptionsRequired2);
                        setOpen(true);
                      }}
                      size={"sm"}
                    >
                      <FileCopy />
                    </Button>
                  </Tooltip>
                </h3>
              </FormLabel>
              <FormText
                fieldProps={{ placeholder: getTranslation("producten.upsell.freeoptions.title", "Title") }}
                name={"freeOptionsRequiredTitle2"}
              />
              <FormAsync
                async={{
                  url:
                    "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                    (menukaartVestigingId ?? vestigingId),
                  searchField: "naam",
                  extraFilters: [
                    {
                      field: "apiId2",
                      operator: "=",
                      value: null,
                    },
                  ],
                }}
                key={"freeOptionsRequired2" + (menukaartVestigingId ?? vestigingId)}
                multiple={true}
                name={"freeOptionsRequired2"}
              />
            </GridLegacy>
            <GridLegacy item key={"freeOptionsRequired3"} lg={4} xs={12}>
              <FormLabel>
                <h3>
                  <TranslationWrapper
                    tDefault={"Vrije opties producten (verplichte keuze)"}
                    tKey={"producten.form.vrijeopties.label.freeOptionsRequired"}
                  />
                  3
                  <Tooltip title={<TranslationWrapper tDefault={"Kopieer"} tKey={"global.tooltip.kopieer"} />}>
                    <Button
                      justIcon
                      onClick={() => {
                        setSelectedField(freeOptionsRequired3);
                        setOpen(true);
                      }}
                      size={"sm"}
                    >
                      <FileCopy />
                    </Button>
                  </Tooltip>
                </h3>
              </FormLabel>
              <FormText
                fieldProps={{ placeholder: getTranslation("producten.upsell.freeoptions.title", "Title") }}
                name={"freeOptionsRequiredTitle3"}
              />
              <FormAsync
                async={{
                  url:
                    "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                    (menukaartVestigingId ?? vestigingId),
                  searchField: "naam",
                  extraFilters: [
                    {
                      field: "apiId2",
                      operator: "=",
                      value: null,
                    },
                  ],
                }}
                key={"freeOptionsRequired3" + (menukaartVestigingId ?? vestigingId)}
                multiple={true}
                name={"freeOptionsRequired3"}
              />
            </GridLegacy>

            <GridLegacy item xs={12}>
              <h3>
                <TranslationWrapper tDefault={"Linked menucard (Kiosks only)"} tKey={"producten.form.menucard.title"} />
              </h3>
            </GridLegacy>
            <FormAsyncTC
              async={{
                url:
                  "core/kaarten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                  (menukaartVestigingId ?? vestigingId),
                searchField: "naam",
              }}
              key={"upsellMenu" + (menukaartVestigingId ?? vestigingId)}
              name={"upsellMenu"}
              nullable={true}
              tDefault={"Groep"}
              tKey={"producten.form.algemeen.label.menukaart_id"}
            />
          </GridLegacy>
        </CardBody>

        {open ? (
          <CopyVrijeOpties
            open={open}
            opties={selectedField}
            originalProductId={id}
            toggle={() => setOpen(!open)}
            vestigingId={vestigingId}
          />
        ) : null}
      </Card>
    </div>
  );
}

export default Vrijeopties;
